import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AmountHelper } from "../../../../helpers/AmountHelper";
import { useTranslation } from "react-i18next";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFLookupBaseDocuments } from "../../../Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupVatType } from "../../../Shared/NewForms/NFLookupVatType";

export const ProductionAndSalesWithPaymentsDetailProducts = () => {
    const tableName = "products";
    const { setValue, getValues } = useFormContext();
    const { t } = useTranslation();

    const handleQuantityChanged = (newQuantity: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            newQuantity,
            getValues(`${tableName}.${index}.price`),
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    const handlePriceChanged = (newPrice: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            getValues(`${tableName}.${index}.quantity`),
            newPrice,
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"products"}>
                <NFLookupBaseDocuments
                    title={t("specificationId")}
                    fieldName="specificationId"
                />
                <NFLookupUnit
                    title={t("Unit")}
                    fieldName="unitId"
                    width={250}
                />
                <NFIntInput
                    fieldName={"quantity"}
                    title={t("Quantity")}
                    width={100}
                    onValueChanged={handleQuantityChanged}
                />
                <NFIntInput
                    fieldName={"price"}
                    title={t("Price")}
                    width={100}
                    onValueChanged={handlePriceChanged}
                />
                <NFIntInput
                    fieldName={"priceWithSale"}
                    title={t("Price With Sale")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"amount"}
                    title={t("Amount")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"vatAmount"}
                    title={t("VAT Amount")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"amountAuto"}
                    title={t("Amount Auto")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"amountWithVat"}
                    title={t("Amount With VAT")}
                    width={100}
                />
                <NFLookupVatType title={t("VAT")} fieldName="vatId" width={250} />
            </NFormTable>
        </>
    );
};
